<div
  class="enable-mfa-modal-wrapper"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="currentStep === 'RESULT' ? 'mfa-result-heading' : 'mfa-action-heading'"
  [attr.aria-describedby]="currentStep === 'RESULT' ? 'mfa-result-description' : 'enable-mfa-description'">
  <button
    type="button"
    class="close-button-wrapper"
    (click)="close()"
    [disabled]="loading"
    [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>

  @if (currentStep !== 'RESULT') {
    <h2 id="mfa-action-heading" class="header" [innerHTML]="actionTitleKey | translate"></h2>
  }
  @if (currentStep === 'RESULT') {
    <h2 id="mfa-result-heading" class="header" [innerHTML]="resultTitleKey | translate"></h2>
  }
  @if (currentStep === 'PASSWORD') {
    <div class="content">
      @if (!loading) {
        <p
          id="enable-mfa-description"
          class="text text--step-description"
          [innerHTML]="passwordStepDescriptionKey | translate"></p>
      }
      @if (!loading) {
        <div class="code-panel">
          <form [formGroup]="passwordForm" class="form" autocomplete="off">
            <nz-form-item>
              <nz-form-label nzFor="mfa-password" nzRequired>
                {{ 'COMMON.LABEL.PASSWORD' | translate }}
              </nz-form-label>
              <nz-form-control>
                <nz-input-group class="mfa-input-group password-input-group" [nzSuffix]="suffixTemplate">
                  <input
                    nz-input
                    id="mfa-password"
                    [type]="isPasswordVisible ? 'text' : 'password'"
                    formControlName="password"
                    autocomplete="off"
                    autocapitalize="off"
                    autocorrect="off"
                    spellcheck="false"
                    data-lpignore="true"
                    data-form-type="other"
                    data-1p-ignore="true"
                    [attr.aria-invalid]="
                      passwordForm.controls.password.invalid && passwordForm.controls.password.touched
                    "
                    [attr.aria-describedby]="
                      passwordForm.controls.password.invalid && passwordForm.controls.password.touched
                        ? 'mfa-password-error'
                        : passwordErrorMessageKey
                          ? 'mfa-password-api-error'
                          : null
                    " />
                  <ng-template #suffixTemplate>
                    <button
                      type="button"
                      class="password-toggle"
                      (click)="isPasswordVisible = !isPasswordVisible"
                      [attr.aria-pressed]="isPasswordVisible"
                      [disabled]="loading"
                      [attr.aria-label]="
                        isPasswordVisible
                          ? ('ENABLE_MFA_MODAL.ACTIONS.HIDE_PASSWORD' | translate)
                          : ('ENABLE_MFA_MODAL.ACTIONS.SHOW_PASSWORD' | translate)
                      ">
                      <mat-icon>
                        {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
                      </mat-icon>
                    </button>
                  </ng-template>
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
            @if (passwordForm.controls.password.invalid && passwordForm.controls.password.touched) {
              <mat-error id="mfa-password-error">
                {{ passwordForm.controls.password.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
            @if (passwordErrorMessageKey) {
              <mat-error id="mfa-password-api-error" [innerHTML]="passwordErrorMessageKey | translate"></mat-error>
            }
          </form>
        </div>
      }
      @if (loading) {
        <div class="spinner spinner--fullscreen" role="status" aria-live="polite">
          <span class="sr-only">{{ 'COMMON.LAYOUT.LOADING' | translate }}</span>
          <mat-spinner [diameter]="56" [attr.aria-hidden]="true"></mat-spinner>
        </div>
      }
    </div>
  }
  @if (currentStep === 'CODE') {
    <div class="content">
      @if (!loading) {
        <p
          id="enable-mfa-description"
          class="text text--step-description"
          [innerHTML]="codeStepDescriptionKey | translate: { phoneNumber: data.phoneNumber }"></p>
      }
      @if (!loading) {
        <div class="code-panel">
          <form [formGroup]="codeForm" class="form" autocomplete="off">
            <nz-form-item>
              <nz-form-label nzFor="mfa-code" nzRequired>
                {{ 'ENABLE_MFA_MODAL.CODE_STEP.CODE_LABEL' | translate }}
              </nz-form-label>
              <nz-form-control>
                <nz-input-group class="mfa-input-group">
                  <input
                    nz-input
                    id="mfa-code"
                    type="text"
                    inputmode="numeric"
                    maxlength="6"
                    formControlName="code"
                    autocomplete="off"
                    autocapitalize="off"
                    autocorrect="off"
                    spellcheck="false"
                    data-lpignore="true"
                    data-form-type="other"
                    data-1p-ignore="true"
                    [attr.aria-invalid]="codeForm.controls.code.invalid && codeForm.controls.code.touched"
                    [attr.aria-describedby]="
                      codeForm.controls.code.invalid && codeForm.controls.code.touched
                        ? 'mfa-code-error'
                        : codeErrorMessageKey
                          ? 'mfa-code-api-error'
                          : null
                    " />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
            @if (codeForm.controls.code.invalid && codeForm.controls.code.touched) {
              <mat-error id="mfa-code-error">
                {{ 'ENABLE_MFA_MODAL.ERRORS.CODE_REQUIRED' | translate }}
              </mat-error>
            }
            @if (codeErrorMessageKey) {
              <mat-error id="mfa-code-api-error" [innerHTML]="codeErrorMessageKey | translate"></mat-error>
            }
          </form>
        </div>
      }
      @if (loading) {
        <div class="spinner spinner--fullscreen" role="status" aria-live="polite">
          <span class="sr-only">{{ 'COMMON.LAYOUT.LOADING' | translate }}</span>
          <mat-spinner [diameter]="56" [attr.aria-hidden]="true"></mat-spinner>
        </div>
      }
    </div>
  }
  @if (currentStep === 'RESULT') {
    <div class="content result-content">
      <div class="result-card" [class.result-card--warning]="resultMfaEnabled === false">
        <mat-icon class="result-icon" [class.result-icon--warning]="resultMfaEnabled === false" aria-hidden="true">
          {{ resultMfaEnabled === false ? 'warning_amber' : 'verified_user' }}
        </mat-icon>
        <p id="mfa-result-description" class="text result-text" [innerHTML]="resultDescriptionKey | translate"></p>
        <p
          class="text text--secondary result-secondary-text"
          [innerHTML]="resultSecondaryDescriptionKey | translate"></p>
      </div>
    </div>
  }

  <div class="action-buttons">
    @if (currentStep === 'PASSWORD') {
      <button type="button" mat-raised-button (click)="close()" [disabled]="loading">
        {{ 'COMMON.ACTION.CANCEL' | translate }}
      </button>
    }
    @if (currentStep === 'RESULT') {
      <button type="button" mat-raised-button color="primary" (click)="close()">
        {{ 'COMMON.ACTION.CLOSE' | translate }}
      </button>
    }
    @if (currentStep !== 'RESULT') {
      <button type="button" mat-raised-button color="primary" (click)="confirm()" [disabled]="loading">
        {{ (currentStep === 'PASSWORD' ? 'ENABLE_MFA_MODAL.ACTIONS.CONTINUE' : 'COMMON.ACTION.CONFIRM') | translate }}
      </button>
    }
  </div>
</div>
